// vendorSlice.js
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import api from '../utils/api';


export const getManufacturerThunk = createAsyncThunk(
  'vendor/getManufacturerThunk',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.getManufacturer();
      return response.data?.data;
    } catch (error) {
      console.log(error);
      toast.error('something went wrong')

    }
  }
);


const initialState = {
  vendorData: {}, 
  loading:false,
  manufacturers:[],
  sameAddress:false
};

const vendorSlice = createSlice({
  name: 'vendor',
  initialState,
  reducers: {
    setVendorData: (state, action) => {
      state.vendorData = { ...state.vendorData, ...action.payload };
    },
    setVendorAddress: (state, action) => {
      state.sameAddress = !state.sameAddress
    },
    deletevendorData:(state,action)=>{
      state.vendorData = {}
    }
  },
   extraReducers: (builder) => {
      builder
  
        .addCase(getManufacturerThunk.pending, (state) => {
          state.loading = true;
        })
        .addCase(getManufacturerThunk.fulfilled, (state, action) => {
          state.loading = false;
          state.manufacturers = action.payload
        })
        .addCase(getManufacturerThunk.rejected, (state, action) => {
          state.loading = false;
        })
  
 
    },

});

export const { setVendorData,setVendorAddress ,deletevendorData} = vendorSlice.actions;

export default vendorSlice.reducer;
